import {Component, OnInit, AfterViewChecked, HostListener, Inject} from '@angular/core';
import { DOCUMENT } from '@angular/common';




@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
    title = 'superefectivo-clients';
    navbarElement: HTMLElement;
    footerElement: HTMLElement;
    sectionElement: NodeListOf<HTMLElement>;

    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.sectionHeightHhandler();
    }

    @HostListener('window:load', ['$event'])
    load() {
        this.sectionElement = document.querySelectorAll('.page-section-one > .row');
        this.sectionHeightHhandler();
    }

    ngOnInit(): void {
        this.navbarElement = document.querySelector('.navbar-simple');
        this.footerElement = document.querySelector('.footer');
    }

    ngAfterViewChecked(): void {
        this.sectionElement = document.querySelectorAll('.page-section-one > .row');
        this.sectionHeightHhandler();
    }

    sectionHeightHhandler() {
        if (this.sectionElement && this.navbarElement && this.footerElement) {
            this.sectionElement.forEach(element => {
                 element.style.minHeight = `calc(100vh - ${(this.navbarElement.getBoundingClientRect().height + this.footerElement.getBoundingClientRect().height) + 20}px`;
            });
        }
    }
    loadStyle(styleName: string) {
        const head = this.document.getElementsByTagName('head')[0];
    
        let themeLink = this.document.getElementById(
          'client-theme'
        ) as HTMLLinkElement;
        if (themeLink) {
          themeLink.href = styleName;
        } else {
          const style = this.document.createElement('link');
          style.id = 'client-theme';
          style.rel = 'stylesheet';
          style.href = `${styleName}`;
    
          head.appendChild(style);
        }
      }
}
